import React from 'react'
import { PageContainer } from './TermsAndConditionsStyled'
import { TocContent } from './tncContent'

export default function TermsAndConditionsPage() {
    return (
        <PageContainer>
            <h1 style={{ textAlign: 'center' }}>Spritz Terms of Use</h1>
            <TocContent />
        </PageContainer>
    )
}
